const createProduct = `
mutation createProduct($product: createProductInput!){
  createProduct(product: $product){
    productId{
      plan
      type
      version
    }
  }
}
`

const readAllProducts = `
query products($skip: Int, $limit: Int, $sort: sortInput $where: productWhereInput){
  products_2(skip: $skip, limit: $limit, sort: $sort, where: $where){
    totalCount
    list{
      createdAt
      createdBy{ associatedUser { id name } }
      lastModifiedAt
      lastModifiedBy{ associatedUser { id name } }
      name
      productId{
        plan
        type
        version
      }
      insurer{
        id
        name
        logoUrls{
          typeC
        }
      }
    }
  }
}`

export const Value = `
fragment Value on scalarValue {
  booleanValue dateValue stringValue numberValue
}`

export const TreeMapValues = `
${Value}
fragment TreeMapValues on scalarValue {
  ...Value
  arrayValue {
    ...Value
    objectValue {
      key value { ...Value }
    }
  }
  objectValue {
    key value { ...Value }
  }
}`

const benefit = `
fragment benefit on benefitGraph {
  typeId
  value: value2 {
    ...TreeMapValues
  }
  detailedValue
  isOptional
  name
  children {
    ...children
  }
}`

const getProductBenefits = `
${TreeMapValues}

fragment children on benefitGraph {
  name
  typeId
  value: value2 {
    ...TreeMapValues
  }
  detailedValue
  isOptional
  children {
    typeId
    detailedValue

    value: value2 {
      ...TreeMapValues
    }

    isOptional

    options{
      name
      optionKey
      value
      typeId
    }

    name
  }
}

${benefit}

query product_benefits($skip: Int, $limit: Int, $sort: sortInput $where: productWhereInput){
  product: products_2(skip: $skip, limit: $limit, sort: $sort, where: $where){
    totalCount
    list{
      createdAt
      createdBy{ associatedUser { id name } }
      lastModifiedAt
      lastModifiedBy{ associatedUser { id name } }
      name
      productId{
        plan
        type
        version
      }
      benefitGraph {
        typeId

        value: value2 {
          ...TreeMapValues
        }

        name
        detailedValue
        isOptional

        options {
          name
          optionKey
          value
          typeId

          children {
            typeId
            value
            optionKey
            name
          }

        }
        children {
          ...benefit
        }
      }
      insurer{
        id
        name
        logoUrls{
          typeC
        }
      }
    }
  }
}`

const localizeProduct = `
mutation localizeProduct($l10n: upsertL10nInput){
  upsertL10n(l10n:$l10n){
    errors
    status
  }
}
`

const getProductPricingAndUnderwriting = `
query products($where: productWhereInput){
  products_2(where: $where){
    list{
      name
      productId{
        plan
        type
        version
      }
      insurer{
        id
        name
        logoUrls{
          typeC
        }
      }
      pricing{
        amountLogic
      }
      underwritingRulesJson
    }
  }
}
`

const createPriceLogic = `
mutation createPriceLogic($productId: productIdInput!, $input: priceLogicInput!){
  createPriceLogic(productId: $productId input: $input){
    errors
    status
  }
}
`
const updatePriceLogic = `
mutation updatePriceLogic($productId: productIdInput!, $input: priceLogicInput!){
  updatePriceLogic(productId: $productId input: $input){
    errors
    status
  }
}
`

const deletePriceLogic = `
mutation deletePriceLogic($productId: productIdInput!){
  deletePriceLogic(productId: $productId){
    errors
  }
}`

const addBenefit = `
mutation addBenefit($productId: productIdInput! $input: benefitInput!) {
  addBenefit(productId: $productId input: $input) {
    errors
    errors_2 { code message }
    status
  }
}`

const removeBenefit = `
mutation removeBenefit($productId: productIdInput! $typeId: String!) {
  removeBenefit(productId: $productId typeId: $typeId) {
    errors
    errors_2 { code message }
    status
  }
}
`

const updateProductUnderwriting = `
mutation updateProduct($productId: productIdInput!, $input: updateProductInput){
  updateProduct(productId: $productId input: $input){
    underwritingRulesJson
    pricing{
      amountLogic
    }
  }
}
`

const deleteProduct = `
mutation deleteProduct($productId: productIdInput!){
  deleteProduct(productId: $productId){
      status
  }
}
`

const deleteAllL10n = `
mutation deleteAllL10n($key: String!) {
  deleteAllL10n(key: $key) {
    errors
    status
  }
}
`

const query = {
	readAllProducts,
	getProductPricingAndUnderwriting,
	getProductBenefits
}

const mutation = {
	createProduct,
	localizeProduct,
	createPriceLogic,
	updatePriceLogic,
	deletePriceLogic,
	updateProductUnderwriting,
	addBenefit,
	removeBenefit,
	deleteProduct,
	deleteAllL10n
}

export { query, mutation }
